const routes = [
  {
    path: '/score/rule',
    name: 'score-rule',
    component: () => import('@/views/score/components/ScoreRule.vue'),
    meta: {
      title: '积分规则',
    },
  },
  {
    path: '/score/instruction',
    name: 'score-instruction',
    component: () => import('@/views/score/components/ScoreInstruction.vue'),
    meta: {
      title: '双倍积分奖励说明',
    },
  },
  {
    path: '/score/detail',
    name: 'score-detail',
    component: () => import('@/views/score/components/ScoreDetail.vue'),
    meta: {
      title: '积分明细',
    },
  },
  {
    path: '/score/reward',
    name: 'score-reward',
    component: () => import('@/views/score/DailyReward.vue'),
    meta: {
      title: '日常奖励',
    },
  },
];
export default routes;
